<template>
    <v-list-item :to="{ name: 'M_Complicated wires' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-cable-data</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title>Complicated wires</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemComplicatedWires',
    props: {
        disabled: Boolean,
    }
}
</script>